import DashboardLayout from "../../../../pages/Dashboard/Layout/DashboardLayout.vue";

const ReportsPage = () =>
    import ('./ReportsPage.vue')
export default {
    path: '/',
    component: DashboardLayout,
    children: [{
            path: 'reports',
            name: 'ReportsPage',
            component: ReportsPage
        }
    ]
}
